// extracted by mini-css-extract-plugin
export const content = "Main-module--content--2zAGX";
export const has_sidebar = "Main-module--has_sidebar--1vv7q";